import classes from './UnderBanner.module.scss';
import { useTranslation } from "react-i18next";

const list = [
    'home.underbanner.li_01',
    'home.underbanner.li_02',
    'home.underbanner.li_03',
    'home.underbanner.li_04',
    'home.underbanner.li_05',
    'home.underbanner.li_06',
];

const UnderBanner = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.underBanner}>
                <div className={classes.col}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('home.underbanner.title')}
                    </h2>
                </div>
                <div className={classes.col}>
                    <ul className="font-16">
                        {list.map((li, index) =>
                            <li key={index}>
                                {t(li)}
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default UnderBanner;
